import { useRouter } from 'next/router'
import { useQuery, dehydrate, QueryClient } from 'react-query'
import { GetServerSidePropsContext } from 'next'

import ProjectsApi from 'api/ProjectsApi'

import ProjectDetails from 'components/ProjectDetails'
import ProjectContextSection from 'components/ProjectContextSection'
import SimilarProjects from 'components/Portfolio/SimilarProjects'
import Loading from 'components/ProjectContextSection/Loading'
import MetaTags from 'components/MetaTags'
import { defaultMeta } from 'shared/constants'
import { useEffect } from 'react'
import { AxiosError } from 'axios'
import CaseStudy from 'components/CaseStudy'

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const queryClient = new QueryClient()
  const { query } = context

  await queryClient.prefetchQuery(['projectDetails'], () =>
    ProjectsApi.getProject(String(query?.projectSlug), { expand: 'stats, examples, techStacks' }),
  )

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  }
}

const PortfolioDetails = () => {
  const router = useRouter()
  const { query } = router

  const {
    data: project,
    isFetching,
    error,
  } = useQuery(
    'projectDetails',
    () =>
      ProjectsApi.getProject(String(query?.projectSlug), {
        expand: 'caseStudy, stats, examples, techStacks',
      }),
    {
      enabled: !!query.projectSlug,
    },
  )

  useEffect(() => {
    if (error) {
      if ((error as AxiosError).response?.status === 404) {
        router.push('/')
      }
    }
  }, [error, router])

  const metadata = {
    title: `${project?.title} | The SilverLogic` || defaultMeta.title,
    description: project?.descriptionMetaTag || defaultMeta.description,
    image: project?.logo.fullSize || defaultMeta.image,
  }

  if (isFetching || !project) return <Loading />

  return (
    <>
      <MetaTags data={metadata} />
      <ProjectDetails project={project} />
      <ProjectContextSection project={project} />
      <CaseStudy project={project} />
      <SimilarProjects similarProjects={project?.similarProjects} isFetching={isFetching} />
    </>
  )
}

export default PortfolioDetails
